import styled from 'styled-components'

/** 게임 화면 — 머리줄 없이 보이는 화면 전체(PC 최소 폭 1440px 과 상관없이 창 크기에 딱 맞춘다) */
export const Wrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  background: #000;
`

/** 게임 창 — 테두리·그림자 없이 꽉 차게 */
export const GameFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  background: #000;
`

export const PlaceholderBox = styled.div`
  width: 100%;
  max-width: 1574px;
  flex: 1;
  border-radius: 15px;
  background: #000;
  box-shadow: 0 4px 20px rgba(20, 184, 166, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  color: #fff;

  p {
    font-size: 16px;
    opacity: 0.8;
  }

  button {
    padding: 14px 28px;
    border-radius: 10px;
    background: #14b8a6;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
    &:hover { background: #0d9488; }
    &:active { transform: scale(0.98); }
  }
`
